import React from "react";
import { Drawer, Descriptions, Image, Tag, Typography } from "antd";

const { Text } = Typography;

const statusColor = (s) =>
  ({
    Available: "green",
    Occupied: "red",
    Reserved: "blue",
    Maintenance: "orange",
    UnderMaintenance: "orange",
    Cleaning: "gold",
    Dirty: "brown",
    OutOfService: "magenta",
  }[s] || "default");

const RoomDetailDrawer = ({ open, visible, room, onClose }) => {
  if (!room) return null;

  // Support both props during migration
  const isOpen = open ?? visible ?? false;

  const capacity = room.capacity ?? room.Capacity ?? "N/A";
  const priceNum = Number(room.price ?? 0) || 0;
  const currency = room.currency || "BWP";

  const rawQr = room.qrCodeBase64 ?? room.QRCodeBase64 ?? null;
  const qrSrc = rawQr
    ? String(rawQr).startsWith("data:image")
      ? rawQr
      : `data:image/png;base64,${rawQr}`
    : null;

  const roomNumber = room.roomNumber ?? room.RoomNumber ?? "";
  const status = room.status ?? room.Status ?? "Unknown";

  return (
    <Drawer
      title={`Room Details - ${roomNumber}`}
      placement="right"
      open={isOpen}
      onClose={onClose}
      // width -> size (number is allowed)
      size={720}
      // destroyOnClose -> destroyOnHidden
      destroyOnHidden
    >
      <Descriptions bordered column={2} size="middle">
        <Descriptions.Item label="Room Number">
          {roomNumber || "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Room Type">
          {room.roomTypeName ?? room.roomType?.typeName ?? "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Status" span={2}>
          <Tag color={statusColor(status)}>{status}</Tag>
        </Descriptions.Item>

        <Descriptions.Item label="Price">
          {`${currency} ${priceNum.toFixed(2)}`}
        </Descriptions.Item>

        <Descriptions.Item label="Floor">
          {room.floor ?? room.Floor ?? "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Capacity">{capacity}</Descriptions.Item>

        <Descriptions.Item label="Features" span={2}>
          {room.features ?? room.Features ?? "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Description" span={2}>
          {room.description ?? room.Description ?? "No description available"}
        </Descriptions.Item>

        <Descriptions.Item label="QR Code" span={2}>
          {qrSrc ? (
            <Image src={qrSrc} alt="Room QR Code" width={150} preview={false} />
          ) : (
            <Text type="secondary">No QR Code generated</Text>
          )}
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
};

export default RoomDetailDrawer;
